<template>
  <div class="app-wrapper">
    <div id="screen">
      <navbar />
      <app-main />
    </div>
  </div>
</template>

<script>
import { AppMain, Navbar } from "./components";
import { mapState } from "vuex";
import { checkPro, isJSON } from "@/utils/methods";
// import variables from "@/assets/styles/variables.scss";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
  },
  created() {
    this.$nextTick(params => {
      this.handleScreenAuto();
      // 绑定自适应函数   ---防止浏览器栏变化后不再适配
      window.onresize = () => this.handleScreenAuto();
    });
  },
  beforeDestroy() {},
  computed: {
    socketUrl() {
      return process.env.VUE_APP_SOCKET;
    },
  },
  methods: {
    handleScreenAuto() {
      const designDraftWidth = 1920; //设计稿的宽度
      const designDraftHeight = 1080; //设计稿的高度
      // 根据屏幕的变化适配的比例
      const scale =
        document.documentElement.clientWidth / document.documentElement.clientHeight <
        designDraftWidth / designDraftHeight
          ? document.documentElement.clientWidth / designDraftWidth
          : document.documentElement.clientHeight / designDraftHeight;
      // 缩放比例
      document.querySelector("#screen").style.transform = `scale(${scale}) translate(-50%, -50%)`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  background: url("~@/assets/images/bgc.png") no-repeat center/100% 100%;
  #screen {
    display: inline-block;
    width: 1920px; //设计稿的宽度
    height: 1080px; //设计稿的高度
    transform-origin: 0 0;
    position: absolute;
    left: 50%;
    top: 50%;
  }
}

.footer {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #8f8f8f;
  text-align: center;
  background: #e7e7e7;
  vertical-align: middle;
  .logo {
    height: 12px;
  }
}
</style>
